/**
 * Types and constants.
 *
 * Don't import this directly. Use MusicLib.
 */

export const _romanTriadChordOptions = [
  "I",
  "ii",
  "iii",
  "IV",
  "V",
  "vi",
  "viio",
] as const;

export const _romanSeventhChordOptions = [
  "Imaj7",
  "iimin7",
  "iiimin7",
  "IVmaj7",
  "V7", // dominant
  "vimin7",
  "vii7b5", // half-diminished
] as const;

export const _allChordOptions = [
  ..._romanTriadChordOptions,
  ..._romanSeventhChordOptions,
] as const;

type _RomanTriadChordName = (typeof _romanTriadChordOptions)[number];
type _RomanSeventhChordName = (typeof _romanSeventhChordOptions)[number];
export type _RomanChordName = _RomanTriadChordName | _RomanSeventhChordName;

export type _PlainNoteName =
  | "C"
  | "Db"
  | "D"
  | "Eb"
  | "E"
  | "F"
  | "Gb"
  | "G"
  | "Ab"
  | "A"
  | "Bb"
  | "B";

export type _NoteName =
  | "C2"
  | "Db2"
  | "D2"
  | "Eb2"
  | "E2"
  | "F2"
  | "Gb2"
  | "G2"
  | "Ab2"
  | "A2"
  | "Bb2"
  | "B2"
  | "C3"
  | "Db3"
  | "D3"
  | "Eb3"
  | "E3"
  | "F3"
  | "Gb3"
  | "G3"
  | "Ab3"
  | "A3"
  | "Bb3"
  | "B3"
  | "C4"
  | "Db4"
  | "D4"
  | "Eb4"
  | "E4"
  | "F4"
  | "Gb4"
  | "G4"
  | "Ab4"
  | "A4"
  | "Bb4"
  | "B4"
  | "C5"
  | "Db5"
  | "D5"
  | "Eb5"
  | "E5"
  | "F5"
  | "Gb5"
  | "G5"
  | "Ab5"
  | "A5"
  | "Bb5"
  | "B5";

export type _ScaleType = "major" | "minor";

export const intervals = [
  "P1",
  "m2",
  "M2",
  "m3",
  "M3",
  "P4",
  "A4",
  "P5",
  "m6",
  "M6",
  "m7",
  "M7",
  "P8",
] as const;

export type Interval = (typeof intervals)[number];
